import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitleContainer: {
        position: "absolute",
        left: 0,
        right: 0
    },
    headerTitle: {
        alignSelf: "center"
    },
    contentCenter: {
        alignContent: "center",
        alignItems: "center"
    },
    textCenter: {
        textAlign: "center"
    },
    infoRow: {
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center"
    },
    row: {
        flexDirection: "row"
    },
    pageContainer: {
        flex: 1,
        alignContent: "space-between",
        alignItems: "stretch",
        justifyContent: "space-between"
    },
    flex1: {
        flex: 1
    },
    deleteInfoContainer: {
        alignSelf: "stretch"
    }
});
export default stylesheet;
